import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

// Identificador del tipo de equipo (catálogo eqptt)
export type DeviceKind = string;
export type WarrantyDays = string;

export type EquipmentSecurity = {
  method: 'password' | 'pattern';
  password?: string;
  pattern?: number[]; // indices 0..8
};

export type EquipmentDataState = {
  branchId: string;
  modelId: string;
  deviceKindId: DeviceKind | null;
  imei: string;
  passwordRequired: boolean;
  security?: EquipmentSecurity;
  failure: string;
  diagnostic: string;
  observations: string;
  warrantyId: WarrantyDays | null;
};

export const initialEquipmentDataState: EquipmentDataState = {
  branchId: '',
  modelId: '',
  deviceKindId: null,
  imei: '',
  passwordRequired: false,
  security: undefined,
  failure: '',
  diagnostic: '',
  observations: '',
  warrantyId: null,
};

const equipmentDataSlice = createSlice({
  name: 'equipmentData',
  initialState: initialEquipmentDataState,
  reducers: {
    // Setters unitarios permitidos
    setPasswordRequired(state, action: PayloadAction<boolean>) {
      state.passwordRequired = action.payload;
    },
    setSecurity(state, action: PayloadAction<EquipmentSecurity | undefined>) {
      state.security = action.payload;
    },

    // Upsert masivo (útil al enviar el formulario)
    setEquipmentData(state, action: PayloadAction<Partial<EquipmentDataState>>) {
      Object.assign(state, action.payload);
    },

    // Reset explícito del estado del slice
    resetEquipmentDataState() {
      return initialEquipmentDataState;
    },
  },
  extraReducers: (builder) => {
    // Permite resetear via una acción global si se requiere
    builder.addCase('RESET_EQUIPMENTDATA_STATE', () => initialEquipmentDataState);
  },
});

export const { setPasswordRequired, setSecurity, setEquipmentData, resetEquipmentDataState } =
  equipmentDataSlice.actions;

export default equipmentDataSlice.reducer;
